'use client';

import { Screens } from '@ui/uikit/utils/Screens';
import { Image } from '@utilities/Image';
import { Link } from '@utilities/Link';

import { LogoCarousel } from '../../components/LogoCarousel/LogoCarousel';
import styles from './AppsAndGamesList.module.scss';
import type { ListItem } from './appsAndGamesListConfig';
import { appsAndGamesListConfig } from './appsAndGamesListConfig';

const renderItem = ({ id, href, label, src }: ListItem) => (
  <li key={id} className={styles.item} aria-hidden={id.includes('-clone')}>
    <Link href={href} className={styles.link}>
      <Image src={src} alt={`${id} icon`} width={80} height={80} title={label} />
      {label}
    </Link>
  </li>
);

export const AppsAndGamesList = () => {
  return (
    <Screens.Provider>
      <Screens.Breakpoint at="SMALL">
        <ul className={styles.container}>{appsAndGamesListConfig.map(renderItem)}</ul>
      </Screens.Breakpoint>

      <Screens.Breakpoint greaterThan="MEDIUM" style={{ width: '100%' }}>
        <LogoCarousel duration={40} gap={16} items={appsAndGamesListConfig} renderItem={renderItem} />
      </Screens.Breakpoint>
    </Screens.Provider>
  );
};
